var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "form-group form-group--checkbox-single",
      class: _vm.getClass(),
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { class: `col-sm-${_vm.component.size}` }, [
          !_vm.component.hideLabel
            ? _c("label", [
                _vm._v(_vm._s(_vm.component.label) + "\n        "),
                _vm.isRequired()
                  ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                  : _vm._e(),
              ])
            : _vm._e(),
          _c("div", { staticClass: "checkbox" }, [
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: _vm.setRules(),
                    expression: "setRules()",
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.component.data.currentValue,
                    expression: "component.data.currentValue",
                  },
                ],
                attrs: {
                  type: "checkbox",
                  name: _vm.component.key,
                  disabled: _vm.disabledHandler(),
                  "data-vv-name": _vm.component.key,
                },
                domProps: {
                  checked: _vm.component.data.currentValue,
                  checked: Array.isArray(_vm.component.data.currentValue)
                    ? _vm._i(_vm.component.data.currentValue, null) > -1
                    : _vm.component.data.currentValue,
                },
                on: {
                  focus: function ($event) {
                    return _vm.focusHandler()
                  },
                  blur: function ($event) {
                    return _vm.blurHandler()
                  },
                  change: function ($event) {
                    var $$a = _vm.component.data.currentValue,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.component.data,
                            "currentValue",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.component.data,
                            "currentValue",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.component.data, "currentValue", $$c)
                    }
                  },
                },
              }),
              _c("span", {
                staticClass: "checkbox--text",
                domProps: { innerHTML: _vm._s(_vm.component.data.textValue) },
              }),
            ]),
          ]),
        ]),
      ]),
      _vm.errors.has(_vm.component.key)
        ? _c("span", { staticClass: "help-block help-block--bottom" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 14 14",
                  width: "14",
                },
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      id: "form_icon_error_alert",
                      transform: "translate(-252 -635)",
                    },
                  },
                  [
                    _c("rect", {
                      staticClass: "cls-1",
                      attrs: {
                        id: "rectangle",
                        width: "14",
                        height: "14",
                        transform: "translate(252 635)",
                      },
                    }),
                    _c("path", {
                      staticClass: "cls-2",
                      attrs: {
                        id: "ic_error_outline_24px",
                        d: "M7.4,9.8H8.6V11H7.4ZM7.4,5H8.6V8.6H7.4Zm.594-3A6,6,0,1,0,14,8,6,6,0,0,0,7.994,2ZM8,12.8A4.8,4.8,0,1,1,12.8,8,4.8,4.8,0,0,1,8,12.8Z",
                        transform: "translate(251 634)",
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v("\n    " + _vm._s(_vm.errors.first(_vm.component.key))),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }